import React from "react";
import { OButton } from "./OButton";
import { isFunction } from "../../util/index";

class FileInputButton extends React.Component{
    input = null;
    openInput(){
    	this.input.click();
    }
    render(){
    	const { children, accept, onFileChange, setRef, style } = this.props;
    	if(isFunction(setRef)){
    		setRef(this);
    	}
    	return <div key={this.props.key} style={style}>
    		<OButton {...this.props.buttonProps} onClick={this.openInput.bind(this)}>
    			{children}
    		</OButton>
    		<input ref={ref=>{this.input=ref;}} hidden type="file" accept={accept} onChange={onFileChange}/>
    	</div>;
    }
}
FileInputButton.defaultProps = {
	style:undefined,
	onFileChange:(event)=>{},
	accept:["image/png"],
	buttonProps:{},
};
export default FileInputButton;


// WEBPACK FOOTER //
// ./src/components/button/FileInputButton.js